export default ".main-grid {\n  display: grid;\n}\n\n.form-grid {\n  display: grid;\n  grid-auto-flow: column;\n  grid-gap: 10px;\n}";